<template>
  <div class="about">
    <Header :navIndex="navIndex"></Header>
    <div style="width: 100%; background: #f2f2f2">
      <div class="nav">
        <div
          class="item"
          :class="active == index ? 'active' : ''"
          v-for="(item, index) in list"
          :key="index"
          @click="tabChange(item.id)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="wrap">
      <ConcatUs v-if="active == 0" />
      <Door v-if="active == 1"></Door>
    </div>
    <Part5></Part5>
    <XFK></XFK>
  </div>
</template>

<script>
import Header from "../components/Header";
import ConcatUs from "../components/concat/ConcatUs";
import Part5 from "../components/Part5";
import XFK from "../components/XFK";
import Door from "../components/concat/Door";
export default {
  components: { Header, Door, ConcatUs, Part5, XFK },
  name: "concat",
  data() {
    return {
      navIndex: 8,
      active: 0,
      list: [
        { id: 0, name: "联系我们" },
        { id: 1, name: "全国门店" },
      ],
    };
  },
  methods: {
    tabChange(id) {
      // console.log(id);
      this.active = id;
    },
  },
};
</script>

<style scoped lang="less">
.about {
  .nav {
    background: #f2f2f2;
    width: 1033px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    .item {
      cursor: pointer;
      line-height: 60px;
      height: 60px;
      font-size: 20px;
      font-family: MicrosoftYaHei, 微软雅黑;
      font-weight: 400;
      color: #004c31;
      width: 200px;
      margin: 10px;
      background: #dbd9d9;
      border-radius: 50px;
    }
    .active {
      width: 200px;
      background: #004c31;
      color: #ffffff;
      border-radius: 50px;
    }
  }
}
@media screen and (max-width: 450px) {
  .about {
    .nav {
      padding: 32px 0;
      background: #f2f2f2;
      width: 100%;
      height: 60 * 2px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin: 0 auto;
      .item {
        border-radius: 500px;
        width: 200 * 2px;
        background: #dbd9d9;
        cursor: pointer;
        line-height: 60 * 2px;
        height: 60 * 2px;
        font-size: 20 * 2px;
        font-family: MicrosoftYaHei, 微软雅黑;
        font-weight: 400;
        color: #004c31;
      }
      .active {
        width: 200 * 2px;
        background: #004c31;
        color: #ffffff;
        border-radius: 50 * 2px;
      }
    }
  }
}
</style>
